export default "__VITE_ASSET__DWc8E1gS__"